import React, { useState } from 'react'
import Modal from '../../../ReusableComponents/Modal'
import dateFormat from 'dateformat';
import { AEROMEGH_SERVICES, STATUS } from '../../../appConstants';
import { reduceLongName, squareKilometersToAcres } from '../../../ReusableFunctions/reusableFunctions';
import { Button } from '../../../Components/Helper';
import { useLocation, useNavigate } from 'react-router';
import { PDRL_ADMIN_ROUTES, PDRL_FINANCE_ROUTES, PDRL_SUCCESS_ENGI_ROUTES } from '../../../routes';
import OrderCancelModal from '../../../BhuMeetTeams/Operations/reusableComponents/CancelOrderModal';
import { useSelector } from 'react-redux';
export default function RequestDetailsPopup({
    activeTab,
    open,
    onClose,
    existingRequest,
}) {
    const [request, setRequest] = useState(existingRequest);
    const [openCancelOrder, setOpenCancelOrder] = useState(false);
    const navigate = useNavigate();
    const reduxUser = useSelector((state) => state.user.user);
    const { pathname } = useLocation();
    const isTrainingService = request?.type === AEROMEGH_SERVICES.TRAINING
    const isSprayingService = request?.type === AEROMEGH_SERVICES.SPRAYING;
    const isSurveyService = request?.type === AEROMEGH_SERVICES.SURVEY;

    const fieldData = [
        { label: 'Request Number', value: request?.req_number },
        { label: 'Customer Name', value: request?.user_name },
        { label: 'Contact No.', value: request?.user_phone },
        { label: 'Service', value: request?.type },
        { label: 'Service Location', value: request?.field_address, overflow: true },
        isSprayingService && { label: 'Crop', value: request?.crops?.English || request?.crop_name },
        isTrainingService && { label: 'Date', value: request?.date_created ? dateFormat(request.date_created, "dd/mm/yyyy") : "-" },
        isTrainingService && { label: 'Time', value: request?.date_created ? dateFormat(request.date_created, "hh:MM TT") : "-" },
        (isSprayingService || isSurveyService) && { label: 'Date', value: request?.time ? dateFormat(request.time, "dd/mm/yyyy") : "-" },
        // (isSprayingService || isSurveyService) && { label: 'Time', value: request?.time ? dateFormat(request.time, "hh:MM TT") : "-" },
        (isSprayingService || isSurveyService) && {
            label: 'Pilot',
            value: request?.pilot_name ? reduceLongName(request.pilot_name, 20) : "-"
        },
        {
            label: `Status`,
            value: `${request?.status} ${request.status === STATUS.PAID ? `(${request.payment_method === "Offline" ? "Cash" : "UPI"})` : ""}`
        },
        isTrainingService && { label: 'Price', value: request?.price ? request.price + " Rs." : "-" },
        (isSprayingService) && { label: request?.price_by === "acre" ? `Requested Area` : "Requested No of Tank ", value: request?.price_by === "tank" ? request?.field_area : request?.price_by === "acre" ? Number(squareKilometersToAcres(request?.field_area)).toFixed(2) + " Acre" : "-" },
        (isSurveyService) && { label: 'Requested Area', value: request?.field_area ? Number(request?.field_area).toFixed(4) + " Sq/km" : "-" },
        ((isSprayingService && request?.service_completed_area) && {
            label: request.price_by === "acre" ? "Completed Area" : "Completed No Of Tank", value: (request.price_by === "acre" ? Number(squareKilometersToAcres(request.service_completed_area)).toFixed(2) + " Acre" : request.service_completed_area) || "-"
        })
    ].filter(Boolean);

    const Field = ({ label, value, overflow }) => (
        <div className='single_field_wrapper' style={{ lineHeight: overflow ? 1.15 : 1.1 }}>
            <div className='single_field_label' >{label}</div>
            <div className='single_field_value' style={{
                maxHeight: overflow && value?.length > 120 ? "100px" : "none",
                overflowY: overflow && value?.length > 120 ? "auto" : "hidden"
            }}>
                {value || "-"}
            </div>
        </div>
    );


    return (
        <>
            {openCancelOrder && (
                <OrderCancelModal
                    open={openCancelOrder}
                    onClose={() => {
                        setOpenCancelOrder(false);
                    }}
                    onOrderCancel={() => {

                    }}
                />
            )}
            <Modal
                header={activeTab === "ALL" ? 'Request Details ' : 'Order Details '}
                open={open}
                onClose={onClose}
                contentStyle={{ width: "850px", height: "auto" }}
                divider={true}
                headingStyle={{ fontSize: "18px" }}
                iconSize={"18px"}
                headerContainerStyle={{ padding: '20px 40px' }}
            >
                <div className=''>
                    <div className='request_fields_wrapper'>
                        {fieldData.map((field, index) => (
                            <Field key={index} label={field.label} value={field.value} overflow={field.overflow} />
                        ))}
                    </div>
                    {(
                        <Button
                            style={{ margin: "0px 40px 20px auto", width: "120px" }}
                            text={"View Details"}
                            className={"btn-large"}
                            type={"submit"}
                            onClick={() => {
                                let req = { ...request, serviceType: request?.serviceType?.props?.content }
                                if (pathname === PDRL_FINANCE_ROUTES.ORDERS) {
                                    navigate(`${PDRL_FINANCE_ROUTES.REQUESTDETAILS}`, { state: { request: { type: req?.type, id: req?.id, showCancel: pathname === PDRL_ADMIN_ROUTES.DSPDASHBOARD ? true : false } } })
                                } else if (activeTab !== "LEAD" && pathname === PDRL_ADMIN_ROUTES.OPERATIONS_REQUESTS) {
                                    navigate(`${PDRL_ADMIN_ROUTES.OPERATIONS_REQUESTDETAILS}`, { state: { request: { type: req?.type, id: req?.id } } })
                                } else if (activeTab === "LEAD" && pathname === PDRL_SUCCESS_ENGI_ROUTES.USERDETAILS && reduxUser?.bhumeet_role == "Telecaller Sales") {
                                    navigate(`${PDRL_ADMIN_ROUTES.TELECALLERORDERDETAILS}`, { state: { request: { id: req?.id, showCancel: false } } })
                                } else if (activeTab === "LEAD" && (pathname === PDRL_SUCCESS_ENGI_ROUTES.OPERATIONS_REQUESTS || pathname === PDRL_SUCCESS_ENGI_ROUTES.REQUESTS || pathname === PDRL_SUCCESS_ENGI_ROUTES.CUSTOMERSUCESSDSPDASHBOARD || pathname === PDRL_ADMIN_ROUTES.DSPDASHBOARD || pathname === PDRL_ADMIN_ROUTES.USERDETAILS || pathname === PDRL_SUCCESS_ENGI_ROUTES.CSEUSERDETAILS)) {
                                    navigate(`${PDRL_ADMIN_ROUTES.LEAD_DETAILS}`, { state: { request: { id: req?.id, showCancel: (pathname === PDRL_SUCCESS_ENGI_ROUTES.REQUESTS || pathname === PDRL_SUCCESS_ENGI_ROUTES.CUSTOMERSUCESSDSPDASHBOARD || reduxUser.bhumeet_role != 'Admin' || pathname === PDRL_SUCCESS_ENGI_ROUTES.CSEUSERDETAILS) ? false : true } } })
                                }
                                else {
                                    navigate(`${PDRL_ADMIN_ROUTES.REQUESTDETAILS}`, { state: { request: { type: req?.type, id: req?.id, show: true, showCancel: pathname === PDRL_ADMIN_ROUTES.DSPDASHBOARD ? true : false } } })
                                }
                            }}
                        />
                    )}
                </div>
            </Modal>
        </>
    )
}
